package com.essntl.features.address.data.supabase

import com.essntl.features.address.domain.model.AddressModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AddressDto(
    val id: String,
    @SerialName("line_1")
    val line1: String?,
    @SerialName("line_2")
    val line2: String?,
    @SerialName("city")
    val city: String?,
    val state: String?,
    @SerialName("zip_code")
    val zipCode: String?,
    val country: String?,
    val latitude: Double?,
    val longitude: Double?,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String,
    @SerialName("google_description")
    val description: String?,
) {
    fun toModel() =
        AddressModel(
            id = id,
            line1 = line1,
            line2 = line2,
            city = city,
            state = state,
            zipCode = zipCode,
            country = country,
            description = description,
            latitude = latitude,
            longitude = longitude,
            createdAt = createdAt,
            updatedAt = updatedAt,
        )
}